import { createSelector } from 'reselect';
import { RootState } from 'typesafe-actions';
import { getRegionCode, DEFAULT_KZ_REGION } from './location';

export const getEnv = createSelector(
  ({ env }: RootState) => env,
  (env) => env || {},
);

export const getOrchestratorHost = createSelector(
  getEnv,
  getRegionCode,
  ({ ORCHESTRATOR_HOST, ORCHESTRATOR_HOST_KZ, ORCHESTRATOR_BACKEND_HOST }, regionCode) => {
    if (__IS_SERVER__) {
      return ORCHESTRATOR_BACKEND_HOST;
    }

    if (regionCode === DEFAULT_KZ_REGION && ORCHESTRATOR_HOST_KZ) {
      return ORCHESTRATOR_HOST_KZ;
    }

    return ORCHESTRATOR_HOST;
  },
);

export const getProductsCompareOrchestratorHost = createSelector(
  getEnv,
  getRegionCode,
  (
    {
      PRODUCTS_COMPARE_ORCHESTRATOR_HOST,
      PRODUCTS_COMPARE_ORCHESTRATOR_HOST_KZ,
      PRODUCTS_COMPARE_ORCHESTRATOR_BACKEND_HOST,
    },
    regionCode,
  ) => {
    if (__IS_SERVER__) {
      return PRODUCTS_COMPARE_ORCHESTRATOR_BACKEND_HOST;
    }

    if (regionCode === DEFAULT_KZ_REGION && PRODUCTS_COMPARE_ORCHESTRATOR_HOST_KZ) {
      return PRODUCTS_COMPARE_ORCHESTRATOR_HOST_KZ;
    }

    return PRODUCTS_COMPARE_ORCHESTRATOR_HOST;
  },
);

export const getCloudinaryCloud = createSelector(
  getEnv,
  ({ MEDIA_CLOUDINARY_CLOUD }) => MEDIA_CLOUDINARY_CLOUD,
);

export const getRequestUrl = createSelector(getEnv, ({ requestUrl }) => requestUrl);
export const getServerFetchDataTimeout = createSelector(
  getEnv,
  ({ SERVER_FETCH_DATA_TIMEOUT }) => SERVER_FETCH_DATA_TIMEOUT,
);

export const getFlowboxKey = createSelector(getEnv, ({ FLOWBOX_KEY }) => FLOWBOX_KEY);

export const getExperimentsDomain = createSelector(getEnv, (env) => env.EXPERIMENTS_DOMAIN || '');

export const getRobotintConfig = createSelector(getEnv, (env) => {
  return {
    clientId: env.ROBOTINT_CLIENT_ID,
    secret: env.ROBOTINT_SECRET,
    robotintLink: env.ROBOTINT_LINK,
  };
});
